import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--font-apercu-bold%22,%22src%22:%22../../../fonts/apercu-bold.woff2%22,%22display%22:%22swap%22,%22weight%22:%22700%22}],%22variableName%22:%22apercuBold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'apercuBold', 'apercuBold Fallback'",
        fontWeight: 700,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
